module.exports = __webpack_public_path__ + "static/12-8a252dfbe1c2bf59837252a94dc68d68.jpg";